var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 7.5H5.8a3.3 3.3 0 1 1 0-6.5h2.4v3H5.8a.3.3 0 1 0 0 .5h2.4v3Zm7.6 9H18a3.3 3.3 0 1 1 0 6.5h-2.2v-3H18a.3.3 0 1 0 0-.5h-2.2v-3ZM7 10.5h10v3H7v-3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnection);
export default __webpack_public_path__ + "static/media/icon_connection.09f3b82081139f1dfd7ec37b912f3d78.svg";
export { ForwardRef as ReactComponent };